import React from 'react'

export default props => <svg
  width="21"
  height="21"
  viewBox="0 0 21 21"
  fill="none"
  {...props}
>
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M10.5 0C9.47656 0 8.64648 0.830078 8.64648 1.85352V8.64648H1.85352C0.830078 8.64648 0 9.47656 0 10.5C0 11.5234 0.830078 12.3516 1.85352 12.3516H8.64648V19.1465C8.64648 20.1699 9.47656 21 10.5 21C11.5234 21 12.3516 20.1699 12.3516 19.1465V12.3516H19.1465C20.1699 12.3516 21 11.5234 21 10.5C21 9.47656 20.1699 8.64648 19.1465 8.64648H12.3516V1.85352C12.3516 0.830078 11.5234 0 10.5 0Z"
    fill="url(#RepositorySelect_CrossIconSvg_paint0_linear)"
    fillOpacity="0.5"
  />
  <defs>
    <linearGradient id="RepositorySelect_CrossIconSvg_paint0_linear" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(21 21) scale(21) rotate(180)">
    <stop stopColor="#909AAA"/>
    <stop offset="1" stopColor="#7A808C"/>
    </linearGradient>
  </defs>
</svg>



// WEBPACK FOOTER //
// ./src/pages/RepositorySelect/CrossIconSvg.js